<template>
  <div class="footer-sidebar d-flex flex-column">
    <ul class="nav flex-column">
      <li class="nav-item parent">
        <a
          class="d-flex justify-content-between align-items-center"
          href="#"
          :data-tooltip="sidebarIconOnly ? t('common.help') : undefined"
          @click.prevent="toggleHelp"
          :class="{ open: isOpen }"
        >
          <span class="sidebar-link-content">
            <i class="bi bi-info-circle"></i>
            <span class="sidebar-link-text">{{ t('common.help') }}</span>
          </span>
          <i class="bi bi-caret-down-fill"></i>
        </a>
        <div
          class="sidebar-submenu"
          :class="{ 'sidebar-submenu--open': isOpen }"
          :aria-hidden="!isOpen"
        >
          <div class="sidebar-submenu__inner">
            <ul class="list-unstyled mb-0">
              <li class="children">
                <a
                  href="/Инструкция RTMS v.1.pdf"
                  download
                  >{{ t('manualRtms') }}</a
                >
              </li>
              <li class="children">
                <a
                  href="/Инструкция_Redmine.pdf"
                  download
                  >{{ t('manualRedmine') }}</a
                >
              </li>
              <li class="children">
                <a
                  href="//redmine.atd.systems"
                  target="_blank"
                  >{{ t('createTicket') }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
    <div class="bottom-block">
      <p class="m-0 sidebar-footer-meta">
        SOYKA:LTMS {{ VERSION }}<br />
        {{ t('common.developedBy') }}
        <a
          href="//atd.systems"
          target="_blank"
          class="sidebar-footer-link"
          >ATD.Systems</a
        >
      </p>
    </div>
  </div>
</template>

<i18n>
{
  "ru": {
    "manualRtms": "RTMS Manual",
    "manualRedmine": "Redmine Manual",
    "createTicket": "Create ticket"
  },
  "en": {
    "manualRtms": "RTMS Manual",
    "manualRedmine": "Redmine Manual",
    "createTicket": "Create ticket"
  }
}
</i18n>

<script setup>
import { shallowRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '@/stores/ui'
import config from '@/config'

const { t } = useI18n()
const isOpen = shallowRef(false)
const { sidebarIconOnly } = storeToRefs(useUiStore())
const VERSION = config.VITE_VERSION

function toggleHelp() {
  if (!sidebarIconOnly.value) {
    isOpen.value = !isOpen.value
    return
  }

  sidebarIconOnly.value = false
  isOpen.value = true
}
</script>
